import { render, staticRenderFns } from "./PaymentBoxContent.vue?vue&type=template&id=b7ca8f40&scoped=true"
import script from "./PaymentBoxContent.vue?vue&type=script&lang=js"
export * from "./PaymentBoxContent.vue?vue&type=script&lang=js"
import style0 from "./PaymentBoxContent.vue?vue&type=style&index=0&id=b7ca8f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ca8f40",
  null
  
)

export default component.exports